import ko from 'knockout';
import template from 'raw-loader!./user-details-container-view.html';
import '../user-details-view';

function UserDetailsContainerView(params) {

  var self = this;

  self.dataProvider = params.dataProvider;
  self.route = params.route;
  self.view = self.route().view;

}

UserDetailsContainerView.prototype.dispose = function() {};

export default UserDetailsContainerView;

ko.components.register('historical2-user-details-container-view', { template, viewModel: UserDetailsContainerView });
